import { render, staticRenderFns } from "./TransferRegistrarsContainer.vue?vue&type=template&id=51610f12&scoped=true&lang=html&"
import script from "./TransferRegistrarsContainer.vue?vue&type=script&lang=js&"
export * from "./TransferRegistrarsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TransferRegistrarsContainer.vue?vue&type=style&index=0&id=51610f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51610f12",
  null
  
)

export default component.exports